
import Badge from 'vux/src/components/badge/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Sticky from 'vux/src/components/sticky/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Search from 'vux/src/components/search/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'


export default {
directives: {
TransferDom
},
components: {
Badge,
Flexbox,
FlexboxItem,
Sticky,
Tab,
TabItem,
Search,
Group,
Cell,
XButton,
Confirm,
XDialog
},

activated () {
console.log('activated...')



document.getElementById('vux_view_box_body').scrollTop = this.$store.state.orderListScrollTop
},
created() {
this.initPageData()
},
mounted:function(){
},

computed: {

},
watch: {
},
data() {
return {
dialogMsg: '',
showHideOnBlur:false,
itemId:0,
OrderStatusCount: {

toAuditNum: 0,

toRefundNum: 0,

toConfirmNum: 0,

toCheckInNum: 0
},
page: 1,
height: window.innerHeight, // 当前页面的高度
index: 0,
index01: 0,
results: [],
orderList: [],
value: '张三/18888888888',
shopId: this.$route.params.shopId,
orders: null,
ordersIndex: null,
show5: false,
changePriceData:{
orderNo: null,
TotalPrice: null,
},
auditOrderData:{

confirm: false, // 默认关闭
confirmMsg: null, // 提示框内内容
refused: '拒绝改价请求',
agreed: '同意改价请求',
checkResult: null, // 审核结果
checkRemark: null, // 审核备注
orderNo: null,
},
confirmOrderData:{

confirm: false, // 默认关闭
confirmMsg: null, // 提示框内内容
refused: '确认无房',
agreed: '确认有房',
checkResult: null, // 审核结果
checkRemark: null, // 审核备注
orderNo: null,
},

consumeOrderData:{

confirm: false, // 默认关闭
confirmMsg: null, // 提示框内内容
refused: '取消核销',
agreed: '确认核销',
checkResult: null, // 审核结果
checkRemark: null, // 审核备注
orderNo: null,
},

refundOrderData:{

confirm: false, // 默认关闭
confirmMsg: null, // 提示框内内容
refused: '拒绝退款',
agreed: '同意退款',
checkResult: null, // 审核结果
checkRemark: null, // 审核备注
orderNo: null,
},

}
},
methods: {

initPageData() {


this.orders = {'all':[],'audit':[],'confirm':[],'refund':[],'checkin':[]}
this.ordersIndex =  [['all', 0],['audit', 0],['confirm', 0],['refund', 0],['checkin', 0]]

this.getOrderStatusJump()

this.initOrderStatusCount()
},
getOrderStatusJump() {
let type = 0
switch(this.$route.query.t) {
case 'all':

break;
case 'audit':
type = 1;
break;
case 'confirm':
type = 2;
break;
case 'refund':
type = 3;
break;
case 'checkin':
type = 4;
break;
default:
}
this.index = type
this.onItemClick(type)
},
editPriceEvent(orderNo, Price){
this.changePriceData.orderNo = orderNo
this.changePriceData.TotalPrice = Price
this.show5 = true
},
auditOrderEvent(orderNo, type){
this.auditOrderData.orderNo = orderNo

if (type == 1) {
this.auditOrderData.checkResult = 'PASS'
this.auditOrderData.confirmMsg = this.auditOrderData.agreed
}else{
this.auditOrderData.checkResult = 'REJECT'
this.auditOrderData.confirmMsg = this.auditOrderData.refused
}

this.auditOrderData.confirm = true
},
confirmOrderEvent(orderNo, type){
this.confirmOrderData.orderNo = orderNo

if (type == 1) {
this.confirmOrderData.checkResult = 'PASS'
this.confirmOrderData.confirmMsg = this.confirmOrderData.agreed
}else{
this.confirmOrderData.checkResult = 'REJECT'
this.confirmOrderData.confirmMsg = this.confirmOrderData.refused
}

this.confirmOrderData.confirm = true
},
consumeOrderEvent(orderNo, type){
this.consumeOrderData.orderNo = orderNo

if (type == 1) {
this.consumeOrderData.checkResult = 'PASS'
this.consumeOrderData.confirmMsg = this.consumeOrderData.agreed
}else{
this.consumeOrderData.checkResult = 'REJECT'
this.consumeOrderData.confirmMsg = this.consumeOrderData.refused
}

this.consumeOrderData.confirm = true
},
refundOrderEvent(orderNo, type){
this.refundOrderData.orderNo = orderNo

if (type == 1) {
this.refundOrderData.checkResult = 'PASS'
this.refundOrderData.confirmMsg = this.refundOrderData.agreed
}else{
this.refundOrderData.checkResult = 'REJECT'
this.refundOrderData.confirmMsg = this.refundOrderData.refused
}

this.refundOrderData.confirm = true
},
onCancel () {
console.log('on cancel')
},
onHide () {
console.log('on hide')
},
onShow5 () {
this.$refs.confirm5.setInputValue('')
},
onConfirm5 (val) {
let price = parseInt(val)
console.log(price)
this.$refs.confirm5.setInputValue('')
if (price == null || price === '' || isNaN(price)) {
this.dialogMsg = '修改的订单价格必须为数字，并且大于0'
this.showHideOnBlur = true
return
}

let shopId = this.shopId
let orderNo = this.changePriceData.orderNo
let totalPrice = this.changePriceData.TotalPrice
let _this = this
_this.axios.post('/v1/shop/'+shopId+'/order/'+ orderNo +'/changePrice', {
origTotalPrice: totalPrice,
changeTotalPrice: price,
}).then(function (response) {
if (response.data.code == 0) {
_this.dialogMsg = '改价成功'
_this.showHideOnBlur = true

_this.initPageData()
} else {
_this.dialogMsg = response.data.msg
_this.showHideOnBlur = true
}
}).catch(function (response) {
console.log(response);
});
},

onShowAudit(){
this.$refs.confirmAudit.setInputValue(this.auditOrderData.confirmMsg)
},

onConfirmAudit(value){

let shopId = this.shopId
let checkResult = this.auditOrderData.checkResult
let orderNo = this.auditOrderData.orderNo
let _this = this
_this.axios.post('/v1/shop/'+shopId+'/order/'+ orderNo +'/changePriceCheck', {
checkResult: checkResult,
checkRemark: value,
}).then(function (response) {
if (response.data.code == 0) {
_this.dialogMsg = '操作成功'
_this.showHideOnBlur = true

_this.initPageData()
} else {
_this.dialogMsg = response.data.msg
_this.showHideOnBlur = true
}
}).catch(function (response) {
console.log(response);
});
},

onShowConfirm(){
this.$refs.confirmConfirm.setInputValue(this.confirmOrderData.confirmMsg)
},

onConfirmConfirm(value){

let shopId = this.shopId
let checkResult = this.confirmOrderData.checkResult
let orderNo = this.confirmOrderData.orderNo
let _this = this
_this.axios.post('/v1/shop/'+shopId+'/order/'+ orderNo +'/shopConfirm', {
checkResult: checkResult,
checkRemark: value,
}).then(function (response) {
if (response.data.code == 0) {
_this.dialogMsg = '操作成功'
_this.showHideOnBlur = true

_this.initPageData()
} else {
_this.dialogMsg = response.data.msg
_this.showHideOnBlur = true
}
}).catch(function (response) {
console.log(response);
});
},

onShowConsume(){
this.$refs.confirmConsume.setInputValue(this.consumeOrderData.confirmMsg)
},

onConfirmConsume(value){

let shopId = this.shopId
let checkResult = this.consumeOrderData.checkResult
let orderNo = this.consumeOrderData.orderNo
let _this = this
_this.axios.post('/v1/shop/'+shopId+'/order/'+ orderNo +'/consume', {
checkResult: checkResult,
checkRemark: value,
}).then(function (response) {
if (response.data.code == 0) {
_this.dialogMsg = '操作成功'
_this.showHideOnBlur = true

_this.initPageData()
} else {
_this.dialogMsg = response.data.msg
_this.showHideOnBlur = true
}
}).catch(function (response) {
console.log(response);
});
},

onShowRefund(){
this.$refs.confirmRefund.setInputValue(this.refundOrderData.confirmMsg)
},

onConfirmRefund(value){

let shopId = this.shopId
let checkResult = this.refundOrderData.checkResult
let orderNo = this.refundOrderData.orderNo
let _this = this
_this.axios.post('/v1/shop/'+shopId+'/order/'+ orderNo +'/refundCheck', {
checkResult: checkResult,
checkRemark: value,
}).then(function (response) {
if (response.data.code == 0) {
_this.dialogMsg = '操作成功'
_this.showHideOnBlur = true

_this.initPageData()
} else {
_this.dialogMsg = response.data.msg
_this.showHideOnBlur = true
}
}).catch(function (response) {
console.log(response);
});
},
openOrderDetail(orderId) {

this.$store.commit('updateOrderListScrollTopPosition',
{top:document.getElementById('vux_view_box_body').scrollTop})
console.log(this.$store.state);
console.log('订单ID:', orderId);
let shopId = this.shopId
this.$router.push({
path: '/shop/'+shopId+'/order/'+ orderId
});
},
onItemClick(type) {
this.itemId = type

this.ordersIndex[type][1] = 1
this.queryOrderList(type)

},
setFocus() {
this.$refs.search.setFocus()
},
resultClick(item) {
window.alert('you click the result item: ' + JSON.stringify(item))
},
getResult(val) {
console.log('on-change', val)
this.results = val ? getResult(this.value) : []
},
onSubmit() {
this.$refs.search.setBlur()
this.$vux.toast.show({
type: 'text',
position: 'top',
text: 'on submit'
})
},
onFocus() {
console.log('on focus')
},
onCancel() {
console.log('on cancel')
},
initOrderStatusCount(){
let shopId = this.shopId
let _this = this;
_this.axios.get('/v1/shop/'+shopId+'/orderStatusNumber', null, {
headers: {}
}).then(function (response) {

_this.OrderStatusCount = response.data.data
}).catch(function (response) {
console.log(response);
});
},
/**
* 订单列表查询
* @param type
*/
queryOrderList(type){
let typeStr = this.ordersIndex[type][0]
let page = this.ordersIndex[type][1]
let shopId = this.shopId
let _this = this;
_this.axios.post('/v1/shop/'+shopId+'/orders', {type:typeStr, page:page}, {
headers: {}
}).then(function (response) {


if (response.data.data != undefined && response.data.data.length > 0) {
if (page < 2) {
_this.orders[typeStr] = []
}
let data = response.data.data
for (let i = 0; i < data.length; i++) {
_this.orders[typeStr].push({
orderNo: data[i].order_no,
goodsName: data[i].goods_name,
goodsNum: data[i].quantity,
checkInTime: data[i].check_in_date,
checkInWeek: data[i].check_in_week,
checkOutTime: data[i].check_out_date,
checkOutWeek: data[i].check_out_week,
nights: data[i].nights, // 住了几晚
price: data[i].price,
totalPrice: data[i].total_price,
contact: data[i].guest_names,
sourceName: data[i].source_name,
statusName: data[i].status_desc,
status: data[i].status,
changePriceCount: data[i].change_price_count
})
}
_this.ordersIndex[type][1] = _this.ordersIndex[type][1]+1
}
}).catch(function (response) {
console.log(response);
});
},
}
}

function formatOrder(data) {
let rs = []
for (let i = 0; i < data.length; i++) {
rs.push({
orderNo: data[i].order_no,
goodsName: data[i].goods_name,
goodsNum: data[i].quantity,
checkInTime: data[i].check_in_date,
checkInWeek: data[i].check_in_week,
checkOutTime: data[i].check_out_date,
checkOutWeek: data[i].check_out_week,
nights: data[i].nights, // 住了几晚
price: data[i].price,
totalPrice: data[i].total_price,
contact: data[i].guest_names,
sourceName: data[i].source_name,
statusName: '待确认',
status: data[i].status
})
}
return rs
}

function getResult(val) {
let rs = []
for (let i = 0; i < 20; i++) {
rs.push({
title: `${val} result: ${i + 1} `,
other: i
})
}
return rs
}



// WEBPACK FOOTER //
// ./src/components/order/List.vue